export class ServiceCategory {
  public id: string;
  public category: string;
  public sortOrder: number;
  public selected: boolean = false;
}
